const intercomIfLoaded = () =>
  typeof window.Intercom === "function" ? window.Intercom : null

const openHelpCenter = () =>
  window.open("https://help.kit.com/", "_blank", "noreferrer")

export const startNewIntercomConversation = () => {
  const intercomApi = intercomIfLoaded()

  if (intercomApi) {
    intercomApi("showNewMessage")
    return
  }

  openHelpCenter()
}

export const showIntercomHome = () => {
  const intercomApi = intercomIfLoaded()

  if (intercomApi) {
    intercomApi("showSpace", "home")
    return
  }

  openHelpCenter()
}
